<template>
    <v-select
        class="search-product-form"
        :placeholder="placeholder"
        :filterable="false"
        :filter="fuseOrdersSearchFilter"
        :getOptionLabel="option => option.tiny_name"
        :options="products"
        @search="onSearch"
        @input="onSearchInput">
        <div slot="no-options">
            <template v-if="search">
                Aucun produit ne correspond à votre recherche
            </template>
            <template v-else>
                {{ placeholder }}
            </template>
        </div>
        <template #option="product">
            <span class="text-muted">{{ product.sku }} - <small>{{ product.category.name }}</small></span>
            <br>
            {{ product.tiny_name }}
        </template>
    </v-select>
</template>

<script>
    import vSelect from 'vue-select';
    import {usePostRequest} from "./compositions/axios/postRequest";
    import Fuse from "fuse.js"

    export default {
        name: "SearchProductForm",

        components: {
            vSelect,
        },

        setup() {
            const {
                loading: sending,
                errors,
                post
            } = usePostRequest();

            return {
                sending,
                errors,
                post
            };
        },

        data: function () {
            return {
                products: [],
                search: null,
            };
        },

        props: {
            placeholder: {
                type: String,
                required: true,
            },
        },


        methods: {
            onSearch(search, loading) {
                loading(true);
                this.search = search;
                this.doSearch(loading, search);
            },

            async doSearch(loading, search) {
                if (search) {
                    const data = await this.post(`/espace-employes/produits/recherche/json`, {
                        search: search
                    });
                    if (data) {
                        this.products = data.products.map(function(item, index) {
                            return {
                                index,
                                ...item,
                            }
                        });
                    }
                } else {
                    this.products = [];
                }
                loading(false);
            },

            onSearchInput(productSelected) {
                this.$emit('selected', productSelected);
            },

            fuseOrdersSearchFilter (options, search) {
                const fuse = new Fuse(options, {
                    keys: ['sku', 'name'],
                    shouldSort: true,
                    includeScore: true,
                });
                let fuseList = search.length ? fuse.search(search) : fuse.list;
                let filtered = [];
                for (const key in fuseList) {
                    filtered.push(fuseList[key].item);
                }
                return filtered;
            },
        },
    }
</script>
